import React from 'react'
import {Dropdown} from 'semantic-ui-react'
import {buyerOptions} from '../vendor-orders/options'

const VpoBuyerSelect = (buyer, fieldOnChange) => {
  return (
    <span style={{width: '225px', display: 'inline-block', marginLeft: '15px'}}>
      <Dropdown
        placeholder='Buyer - ALL' fluid selection multiple search options={buyerOptions}
        onChange={fieldOnChange} name='buyer' value={buyer}/>
    </span>
  )
}

export default VpoBuyerSelect
